import { get, remove } from '../helpers/apiHelpers';
import types from '../helpers/constants';

export const fetchMealSizes = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/sizes', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_MEALSIZES,
      payload: {
        mealSizes: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchMealSize =
  (id, params = {}) =>
  dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`/sizes/${id}`, params).then(response => {
      dispatch({
        type: types.FETCH_MEALSIZE,
        payload: {
          name: response.name,
          position: response.position,
        },
      });
      return response;
    });

export const removeMealSize = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/sizes/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_MEALSIZE,
      payload: {
        mealSizeId: id,
      },
    });
  });
